import { render, staticRenderFns } from "./FormMetaDatasource.vue?vue&type=template&id=2f9e896b&lang=pug"
import script from "./FormMetaDatasource.vue?vue&type=script&lang=js"
export * from "./FormMetaDatasource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9e896b')) {
      api.createRecord('2f9e896b', component.options)
    } else {
      api.reload('2f9e896b', component.options)
    }
    module.hot.accept("./FormMetaDatasource.vue?vue&type=template&id=2f9e896b&lang=pug", function () {
      api.rerender('2f9e896b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormMetaDatasource.vue"
export default component.exports